// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import ErrorImg from '../../../../../assets/images/pic_error_internet.svg';
import Button from '../../../../Button';
import Note from './Note';

const otherS = {
  EmptyContainer: styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  InfoText: styled.span`
    text-align: center;
    font-size: 16px;
    color: #666666;
  `,
  ErrorImage: styled.img.attrs({ src: ErrorImg, alt: 'error-image'})``,
  Container: styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
  `,
  Note: styled(Note)``,
  InputContainer: styled.div`
    flex-shrink: 0;
    padding: 10px;
    display: flex;
    background: #FFF;
    box-shadow: 0px -4px 5px 0px #66666633;
  `,
  InputBox: styled.textarea.attrs({ rows: 1 })`
    max-height: 280px;
    flex: 1;
    font-size: 16px;
    line-height: 20px;
    color: #434343;
    margin-right: 19px;
    width: 100%;
    flex-grow: 1;
    padding-right: 19px;
    background: transparent;
    border: 0px;
    resize: none;

    &:focus {
      outline: none;
    }
    &::placeholder {
      font-size: 16px;
      line-height: 23px;
      color: #A6A6A6;
    }
  `,
  InputToolBox: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  `,
  InputMessageCount: styled.div`
    font-size: 12px;
    color: #848484;
    margin-bottom: 6px;
    text-align: right;
  `,
  InputSendButton: styled(Button)`
    width: 60px;
    height: 30px;
    box-shadow: none;
  `,
  RetryButton: styled.i`
    font-size: 16px;
    color: #EF8200;
    cursor: pointer;
    border-bottom: 1px solid #EF8200;
  `
};

export const S = {
  ...otherS,
  NotesContainer: styled.div`
    overflow: auto;
    flex: 1;
    padding: 14px 12px;

    & > ${otherS.Note} + ${otherS.Note} {
      margin-top: 8px;
    }
  `,
}
